<template>
  <div class="impressium">
    <header class="impressium-header">
      <h1>{{ STRINGS.IMPRESSIUM }} - Angaben gemäß § 5 DDG</h1>
    </header>

    <main class="main-section">
      <h2>{{ STRINGS.CONTACT }}</h2>
      
      <ContactComp />
      <p>Website: <a :href="ROUTES.DOMAIN" target="_blank" rel="noopener noreferrer">
        {{ ROUTES.DOMAIN }}
      </a></p>


      <h2>Vertreten durch</h2>
      <p>{{ STRINGS.DOCTOR_NAME }}</p>

      <h2>Umsatzsteuer-ID</h2>
      <p>
        Umsatzsteuer-Identifikationsnummer gemäß §27 a Umsatzsteuergesetz:
        {{ STRINGS.VAT_ID }}
      </p>
      <p>Steuernummer: {{ STRINGS.TAX_NUMBER }}</p>
      <p>{{ STRINGS.TAX_OFFICE }}</p>

      <h2>Berufsbezeichnung und berufsrechtliche Regelungen</h2>
      <p>Berufsbezeichnung: Psychologischer Psychotherapeut</p>
      <p>Zuständige Kammer: Psychotherapeutenkammer Nordrhein-Westfalen</p>
      <p>Verliehen in: Remscheid</p>
      <p>
        <a href="https://www.gesetze-im-internet.de/psychthg_2020/BJNR160410019.html">
          Psychotherapeutengesetz - PsychThG
        </a>
      </p>

      <h2>Haftungsausschluss</h2>
      <p>
        Trotz sorgfältiger inhaltlicher Kontrolle übernehmen wir keine Haftung für die Inhalte externer Links.
        Für den Inhalt der verlinkten Seiten sind ausschließlich deren Betreiber verantwortlich.
      </p>

      <h2>Bildnachweis / Icons</h2>
      <p>
        Das 
        <a href="https://thenounproject.com/icon/tree-6753430/" target="_blank" rel="noopener">
          Primäres Icon
        </a>
        auf dieser Website wurde vom Nutzer 
        <a href="https://thenounproject.com/creator/esafb06/" target="_blank" rel="noopener">
          zoo
        </a> 
        erstellt und steht unter der 
        <a href="https://creativecommons.org/licenses/by/3.0/" target="_blank" rel="noopener">
          CC Namensnennung 3.0 Lizenz
        </a>.
      </p>
      <p>
        Das 
        <a href="https://thenounproject.com/icon/leaf-8099956/" target="_blank" rel="noopener">
          Favicon
        </a>
        auf dieser Website wurde vom Nutzer 
        <a href="https://thenounproject.com/creator/studiodanro/" target="_blank" rel="noopener">
          Studio Danro
        </a> 
        erstellt und steht unter der 
        <a href="https://creativecommons.org/licenses/by/3.0/" target="_blank" rel="noopener">
          CC Namensnennung 3.0 Lizenz
        </a>.
      </p>
    </main>
    <div class="divider"></div>
  </div>
</template>

<script lang="ts">
import { STRINGS, ROUTES } from "@/constants";
import { Options, Vue } from "vue-class-component";
import ContactComp from "@/components/ContactComp.vue";

@Options({
  components: {
    ContactComp
  }
})
export default class Impressium extends Vue {
  STRINGS = STRINGS;
  ROUTES = ROUTES;
}
</script>

<style scoped>
.impressium {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.impressium-header {
  max-width: 1000px;
  width: 90%;
  text-align: left;
  padding: 1rem;
  box-sizing: border-box;
}

.impressium-header h1 {
  font-size: 40px;
  margin: 0;
  margin-top: 2rem;
  color: var(--color-text-default);
  word-wrap: break-word;
}

.main-section {
  display: flex;
  flex-direction: column;
  align-items: left;
  text-align: left;
  max-width: 1000px;
  width: 90%;
}

.main-section h2 {
  padding: 0 1rem;
  margin: 0;
  margin-top: 2rem;
}

.main-section p {
  padding: 0 1rem;
  margin: 0;
  margin-top: 0.5rem;
  line-height: 1.5;
}
.divider {
  height: 50px;
}

p a {
  text-decoration: none;
  color: var(--color-text-link);
  transition: color 0.5s ease;
}

p a:hover {
  transition: color 0.2s ease;
  color: var(--color-text-hover);
}
</style>
